import { render, staticRenderFns } from "./about-development.vue?vue&type=template&id=0ebf22e3&scoped=true&"
import script from "./about-development.vue?vue&type=script&lang=js&"
export * from "./about-development.vue?vue&type=script&lang=js&"
import style0 from "./about-development.vue?vue&type=style&index=0&id=0ebf22e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebf22e3",
  null
  
)

export default component.exports